<div
  class="row"
  (click)="handleInquiryClick()"
>
  <div
    baseTruncate
    class="col-2"
  >
    <span class="listview-highlight-text">
      {{ inquiry?.customerDepartment?.name | baseIsEmpty }}
    </span>
    <br />
    <span>{{ inquiry?.customerLocation?.name | baseIsEmpty }}</span>
  </div>
  <div class="col-2">
    <div
      baseTruncate
      class="main-qualification-text"
    >
      {{ inquiry?.mainQualification?.name | baseIsEmpty }}
    </div>
    <base-additional-list
      [list]="inquiry?.qualifications || []"
      firstItemClass="alternative-qualification-text"
    ></base-additional-list>
  </div>
  <div
    baseTruncate
    class="col-1"
  >
    <span *ngIf="inquiry?.createdAt"> {{ inquiry?.createdAt | baseFormatDate }}<br /></span>
    <span>{{ inquiry?.createdBy?.firstName | baseIsEmpty }} {{ inquiry?.createdBy?.lastName | baseIsEmpty }}</span>
  </div>
  <div
    baseTruncate
    class="col-1"
  >
    <span>{{ inquiry?.dateFrom | baseFormatDate | baseIsEmpty }} - </span>
    <br />
    <span *ngIf="!inquiry?.unlimited; else unlimitedDate">
      {{ inquiry?.dateTo | baseFormatDate | baseIsEmpty }}
    </span>
    <ng-template #unlimitedDate>
      <span>{{ inquiry?.dateTo | baseFormatDate | baseIsEmpty }}</span>
      <br />
      <span>({{ 'inquiry.unlimitedUntilMLPShort' | translate }})</span>
    </ng-template>
  </div>
  <div class="col-1">
    <div class="circle-md circle-dark">{{ inquiry?.assignmentCount?.all | baseIsEmpty }}</div>
  </div>
  <div class="col-5">
    <div class="row">
      <div class="col-4 d-flex justify-content-center">
        <base-offers-status
          [state]="baseInquiryStatus.published"
          [confirmedOffers]="inquiry?.offersCount?.confirmed"
          [declinedOffers]="inquiry?.offersCount?.declined"
          [openOffers]="inquiry?.offersCount?.open"
          [needConfirmationOffers]="inquiry?.offersCount?.needsConfirmation"
          [areDeclinedOffersAvailable]="canPreselectOffers"
        ></base-offers-status>
      </div>
      <div
        *ngIf="inquiry"
        class="col-6"
      >
        <base-action-dropdown
          *ngIf="
            canPublishInquiry || (hasCloseInquiryPermission && inquiry.status !== baseInquiryStatus.closed);
            else inquiryStatus
          "
          class="mw-100"
          [items]="inquiryActions"
          [label]="'states.' + baseInquiryStatusValue[inquiry.status]"
          [color]="
            inquiry.status === baseInquiryStatus.unpublished
              ? 'outline-danger'
              : inquiry.status === baseInquiryStatus.closed
              ? 'outline-blue'
              : 'outline-success'
          "
          (listItemClicked)="handleClick($event, inquiry.id!)"
          (click)="$event.stopPropagation()"
        ></base-action-dropdown>
        <ng-template #inquiryStatus>
          <div
            baseTruncate
            [customTooltip]="
              inquiry.closedNote ? inquiry.closedNote : ('inquiry.closeInquiry.closedWithoutReason' | translate)
            "
            [disableTooltip]="!canPublishInquiry && inquiry.status !== baseInquiryStatus.closed"
            class="fw-bold d-inline-block"
            [ngClass]="{
              'inquiry-closed-state': inquiry.status === baseInquiryStatus.closed,
              'text-success': inquiry.status === baseInquiryStatus.published,
              'text-danger': inquiry.status === baseInquiryStatus.unpublished
            }"
          >
            {{ 'states.' + baseInquiryStatusValue[inquiry.status] | translate | uppercase }}
          </div>
        </ng-template>
      </div>
      <div class="col-2 d-flex justify-content-end">
        <base-button
          *ngIf="!inquiry?.directlyInquired && inquiry?.status !== baseInquiryStatus.unpublished"
          [ngbTooltip]="'inquiry.inquiryRecipientsTooltip' | translate"
          placement="top-end"
          color="dark"
          icon="fa-solid fa-split"
          iconClass="pe-1"
          [iconSize]="buttonSizes.md"
          (btnClick)="openInquiredServiceProvidersModal($event)"
        ></base-button>
        <base-button
          *ngIf="!!inquiry?.directlyInquired"
          [ngbTooltip]="directInquiryTooltip"
          placement="top-end"
          color="dark"
          icon="fa-solid fa-user"
          iconClass="pe-1"
          [iconSize]="buttonSizes.md"
        ></base-button>
        <base-button
          class="ps-1"
          [ngbTooltip]="'inquiry.createByCopy' | translate"
          placement="top-end"
          color="dark"
          icon="fa-solid fa-copy"
          [iconSize]="buttonSizes.md"
          stateClass="pe-1"
          (btnClick)="copyInquiryHandler($event)"
        ></base-button>
      </div>
    </div>
  </div>
</div>

<ng-template #staffRequest>
  <base-customer-staff-request-modal
    [modalRef]="newStaffRequestModalRef"
    [inquiry]="copiedInquiry"
    [copiedInquiryId]="inquiry?.id"
    [selectedFilters]="filters"
  ></base-customer-staff-request-modal>
</ng-template>

<ng-template #editStaffRequest>
  <base-customer-staff-request-modal
    [modalRef]="editStaffRequestModalRef"
    [inquiry]="editingInquiry"
    [selectedFilters]="filters"
  ></base-customer-staff-request-modal>
</ng-template>

<ng-template #closeInquiryModal>
  <base-customer-close-inquiry-form [modalRef]="onInquiryCloseModalRef"></base-customer-close-inquiry-form>
</ng-template>

<ng-template #directInquiryTooltip>
  <base-direct-inquiry-tooltip
    *ngIf="inquiry"
    [profileName]="
      inquiry.directlyInquired
        ? inquiry.directlyInquired.profile.firstName + ' ' + inquiry.directlyInquired.profile.lastName
        : ''
    "
    [branchName]="inquiry.directlyInquired?.branch?.name || ''"
  ></base-direct-inquiry-tooltip>
</ng-template>

<ng-template #serviceProviderSelectModal>
  <base-customer-service-provider-select-modal
    [modalRef]="serviceProviderSelectModalRef"
    [inquiryId]="unpublishedInquiryId"
  ></base-customer-service-provider-select-modal>
</ng-template>

<ng-template #inquiredServiceProvidersModal>
  <base-customer-inquired-service-providers-modal
    *ngIf="inquiry"
    [isInquiryClosed]="inquiry.status === baseInquiryStatus.closed"
    [inquiryClosingDate]="inquiry.closed"
    [inquiryId]="inquiry.id"
  ></base-customer-inquired-service-providers-modal>
</ng-template>
